const INTEGRATION_ENDPOINTS = {
	kws:
		import.meta.env.VITE_AZO_API_URL ||
		'https://func-azo-generatetoken-tst-weu-01-adakbxauhah8acdu.westeurope-01.azurewebsites.net/api/ImportReport',
}

export const CAVELL_ENDPOINTS = {
	// Tokens
	EXCHANGE_TOKEN: '/v2/auth',

	// User info
	CURRENT_USER: '/v1/user/attributes',
	UPDATE_USER: '/v1/user/attributes/:userId',
	USER_TEMPLATE: '/v1/user/consultation_presets/:templateId',

	// Templates
	PATIENT_CONTACT_CUSTOM_TEMPLATES: '/v1/user/note-templates',
	PERSONAL_TEMPLATES: '/v1/user/custom-templates',
	PERSONAL_TEMPLATE: '/v1/user/custom-templates/:templateId',

	// User management
	REACTIVATE_USER: '/v1/admin/user/:userId/reactivate',
	DEACTIVATE_USER: '/v1/admin/user/:userId/deactivate',
	RESEND_INVITE: '/v1/admin/user/:userId/resend_invite',
	SET_USER_PASSWORD: '/v1/admin/user/:userId/set_password',
	ORGANIZATION: '/v1/admin/org/:orgId',
}

export const SCRIBE_ENDPOINTS = {
	// Dictations
	TRANSCRIBE_DICTATION: '/v1/scribe/dictate',

	// Patient contacts
	LIVE_TRANSCRIPTION: '/api/v2/live-transcription/',
	DERIVE_GENDER: '/v1/scribe/derive_gender',
	GENERATE_NOTE: '/v1/scribe/summarize_structured',
	EXTRACT_FHIR: '/v1/extract-fhir',
	GENERATE_PATIENT_LETTER: '/v1/scribe/simplify',

	// Templates
	PATIENT_CONTACT_FIXED_TEMPLATES: '/v1/extract-fhir/multi_specialist',

	// Feedback
	FEEDBACK: '/v1/feedback',
}

export const ADMIN_ENDPOINTS = {
	// Integrations
	INTEGRATIONS: '/admin/v1/integration',

	// User info
	CURRENT_INTEGRATION_USER: '/admin/v1/user/attributes',

	// User management
	USER: '/admin/v1/user/:userId',
	USERS: '/admin/v1/user',

	// Licenses - UI naming, better known as "integration users" in the API
	LICENSES: '/admin/v1/integration_user',
	LICENSE: '/admin/v1/integration_user/:licenseId',

	// Organizations
	ORGANIZATIONS: '/admin/v1/integration_tenant',
	ORGANIZATION_INFO: '/admin/v1/integration_tenant/:orgId/info',
	CREATE_ORGANIZATION: '/admin/v1/admin/integration_tenant',
	ORGANIZATION: '/admin/v1/admin/integration_tenant/:orgId',

	// Insights
	USAGE: '/admin/v1/analytics/usage',
	DIAGNOSTICS: '/admin/v1/analytics/diagnostics',
	USER_DIAGNOSTICS: '/admin/v1/analytics/diagnostics/user',
	USER_FEEDBACK: '/admin/v1/analytics/user-feedback',
	REPORTING: '/admin/v1/analytics/reporting',
}

// Unauthenticated endpoints, called via `publicApi` (no auth interceptors)
export const PUBLIC_ENDPOINTS = {
	PUBLIC_FEEDBACK: '/v1/public/feedback',
}

export const EXTERNAL_ENDPOINTS = {
	CAVELL_STATUS: 'https://status.cavell.app/api/v1/summary',
}

const API_ENDPOINTS = {
	...CAVELL_ENDPOINTS,
	...INTEGRATION_ENDPOINTS,
	...SCRIBE_ENDPOINTS,
	...ADMIN_ENDPOINTS,
	...PUBLIC_ENDPOINTS,
	...EXTERNAL_ENDPOINTS,
}

export default API_ENDPOINTS
